import { BaseComponent } from '../../components/common/baseComponent/base.component';

import { ServiceLocator } from './../../ServiceLocator';
import { Component, AfterContentInit, OnDestroy, ElementRef } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { UIService } from '../../ui.service';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '../../user.service';
import { UserPrefs, SignaturePrefs, TasksViewPrefs } from '../../api/UserPrefs-dto';
import { Store } from '@ngrx/store';
import { AppState } from '../../store/AppState';
import { SET_USERPREFS } from '../../store/userPrefs';
import { PropertyService } from '../../properties/property.service';
import { catchError, finalize, takeWhile, tap } from 'rxjs/operators';
import { LanguageService } from '../../../services/language.service';
import { WelcomeNotesDTO, WelcomeNotesService } from '../../components/common/welcomeNotes/welcomeNotes.component';
import { AppConfiguration } from '../../conf/app.configuration';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { HelpService, HelpType } from '../../components/common/help/help.service';
import { ConfirmationService } from 'primeng-lts/api';
import { AuthService } from '../../auth.service';
import { UserPrefsService } from '../../store/user-prefs.service';
import { TokenService } from '../../token.service';
import { EMPTY, timer } from 'rxjs';
import { AfirmaSignatureProvider } from '../../../services/signature/services/afirma.signature-provider';

@Component({
  selector: 'userPrefsPanel',
  templateUrl: 'userPrefsPanel.template.html'
})
export class userPrefsPanelComponent extends BaseComponent
  implements AfterContentInit, OnDestroy {
  userPrefs: UserPrefs;

  loaded = false;
  estadoAutoFirma = '';
  welcomeNotesService: WelcomeNotesService;
  welcomeNotes: Array<WelcomeNotesDTO>;

  recibirNotif: boolean;
  modifyPassAvailable: any;
  is2FAAvailable: any;
  appConfig: AppConfiguration;
  constructor(
    public plycaService: PlycaDataService,
    public userService: UserService,
    private store: Store<AppState>,
    public uiService: UIService,
    private confirmationService: ConfirmationService,
    private propertyService: PropertyService,
    private translate: TranslateService,
    public aFirmaService: AfirmaSignatureProvider,
    public languajeService: LanguageService,
    private elem: ElementRef,
    private helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    private authService: AuthService,
    private userPrefsService: UserPrefsService,
    private tokenService: TokenService
  ) {
    super();
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);
    this.welcomeNotesService = ServiceLocator.injector.get(WelcomeNotesService)
    this.subscribe(this.userPrefsService.getUserPrefs(),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;
        // inicializar la variable por si no viene en las preferencias
        if (!this.userPrefs) {
          this.userPrefs = new UserPrefs();
        }
        if (!this.userPrefs.signaturePrefs) {
          this.userPrefs.signaturePrefs = new SignaturePrefs();
        }
        if (!this.userPrefs.signaturePrefs.keystore) {
          this.userPrefs.signaturePrefs.keystore = this.aFirmaService.getKeystores()[0].value;
        }
        if (!this.userPrefs.tasksViewPrefs) {
          this.userPrefs.tasksViewPrefs = new TasksViewPrefs();
        }
      });


    this.subscribe(
      this.welcomeNotesService.welcomeNotes, notes => {
        if (notes) {
          this.welcomeNotes = notes;
        }
      });
  }



  ngAfterContentInit(): void {
    this.recibirNotif = this.userService.getUser().person.receiveNotifications;
    this.setModifyPassAvailable();
    this.set2FAAvailable();
    this.headerActionsService.setTaskDescription(this.elem, 'UserPrefs.user.pref.option', 'fas fa-user-cog', true);
    this.headerActionsService.clearActions();
    this.subscribe(
      this.headerActionsService.addAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true
      ), () => {
        this.uiService.routeBack();
      });
    this.subscribe(this.helpService.showContextHelpObservable(HelpType.USER_PREF_PANEL));
    this.loaded = true;
  }

  ngOnDestroy(): void {
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));
    this.headerActionsService.clearActions();
    super.ngOnDestroy();
  }

  public isLoaded(): boolean {
    return this.loaded;
  }

  updateRecibirNotif(evt: any) {
    let activate;
    if (evt.checked) {
      console.log('Notificar.');
      activate = true;
    } else {
      console.log('No Notificar.');
      activate = false;
    }
    this.subscribe(
      this.plycaService.setReceiveNotifications(activate));
  }
  clearPrefs() {
    this.confirmationService.confirm({
      message: this.translate.instant('UserPrefs.confirm.message'),
      accept: () => {
        this.userPrefsService.clear();
        if (this.tokenService.isSessionRefreshing()) {
          // Por si se quedo en estado incorrecto el flag de renovacion de token de sesion se
          // da un tiempo maximo para que la renovacion finalice y si no se fuerza
          this.subscribe(timer(0, 1000).pipe(
            takeWhile((counter: number) => this.tokenService.isSessionRefreshing() && counter < 11),
            finalize(() => {
              if (this.tokenService.isSessionRefreshing()) {
                console.warn('Forzando el flag de refresco a false');
                this.tokenService.setRefreshingToken(false);
              }
            })
          ));
        }
        this.userService.removeAllUserExtraParam();
        console.log('Preferencias de usuario reiniciadas.');
      },
      reject() {
        console.log('Se ha cancelado la operación.');
      }
    });
  }


  checkAutoFirma() {
    this.estadoAutoFirma = '';
    this.estadoAutoFirma = 'Comprobando...';
    this.subscribe(this.aFirmaService.check().pipe(
      tap((args: any) => {
        console.log('getLog Autofirma', args);
        this.estadoAutoFirma = 'OK';
      }),
      catchError((args: any) => {
        console.error('Error al conectar con autofirma ', args);
        this.estadoAutoFirma = 'Error en AutoFirma';
        return EMPTY;
      })
    ));
  }

  setModifyPassAvailable() {
    let v = this.appConfig.getValue('modifyPassAvailable');
    if (v == undefined || v == true) {

      this.subscribe(
        this.authService.isPasswordModifiable().pipe(tap((value: boolean) => {
          this.modifyPassAvailable = value;
        })),

      );
    }


  }

  set2FAAvailable() {
    this.subscribe(
      this.propertyService.getProperty('2FA', ''), (value: string) => {

        this.is2FAAvailable = (value != '0');

      });

  }

  save() {
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));

  }
}
